<template>
  <div>
    <div v-for="bank in savedBankList" :key="bank.id" class="mt-2.5">
      <SavedPaymentContainer
        :is-select="bank.isSelect"
        :logo-src="bankSvg"
        :account-number="'*****' + bank.last_four"
        :is-show-edit="false"
        :is-show-delete="mode!='display'"
        :is-clinic="mode==='display'"
        :has-icon-background="true"
        @remove="deleteBankAccount(bank.id)"
        @click="selectBankAccount(bank.id)"
      />
    </div>
    <div v-if="mode!='display'" class="flex flex-col mt-3.5">
      <NewLibraryButton
        color-type="none-stroke"
        class="self-start ach-link-button"
        @click="handleClickLinkAccount"
      >
        <span class="material-icons-outlined mr-2">add</span>
        <p>Link an account</p>
      </NewLibraryButton>
      <NewLibraryButton
        v-if="mode === 'payment'"
        :loading="paymentLoading"
        color-type="dark-blue"
        :class="[isBottom ? 'bottom-fixed' : 'w-full mt-6']"
        @click="payWithSavedAch" 
      >
        Complete Payment {{ currency.symbol + chargeAmount.toFixed(2) }}
      </NewLibraryButton>
    </div>
  </div>    
</template>

<script>
import SavedPaymentContainer from "../SavedPaymentContainer.vue";
import NewLibraryButton from "@/NewLibrary/Button.vue";
import { deleteSavedPaymentApi, getSavedPaymentsApi } from "@/api/va-order-page/newChargingService.js";
import { notify } from '@/utils/notify';
export default {
  components: {
    SavedPaymentContainer,
    NewLibraryButton
  },
  props: {
    accountRole: {
      type: String,
      default: "customer"
    },
    accountId:{
      type: Number,
      default: null
    },
    clinicId: {
      type: Number,
      default: null
    },
    customerId: {
      type: Number,
      default: null
    },
    chargeAmount: {
      type: Number,
      default: 0
    },
    paymentLoading: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: "payment"//3 modes:"payment","setup","display"
    },
    currency: {
      type: Object,
      default: () => ({ name: "USD", symbol: "$"})
    }
  },
  emits: ["clickLinkAccount", "payWithSavedAch"],
  data() {
    return {
      savedBankList: [],
      bankSvg: require("@/assets/orderTest/bank.svg")
    }
  },
  computed: {
    isBottom() {
      return document.location.href.includes('/ordertest') 
        && !document.location.href.includes('order-center');
    }
  },
  mounted() {
    this.callGetSavedAchPaymentsApi();
  },
  methods: {
    handleClickLinkAccount() {
      this.$emit('clickLinkAccount');
    },

    async callGetSavedAchPaymentsApi() {
      try {
        let { data } = await getSavedPaymentsApi({
          customerId: this.customerId,
          clinicId: this.clinicId,
          methodType: "ach"
        });

        let banks = [];
        if (this.accountRole === "clinic") {
          banks = data?.clinic_payment_methods || [];
        } else {
          banks = data?.customer_payment_methods || [];
        }
        this.savedBankList = banks.map((bank, idx) => ({
          ...bank,
          isSelect: idx === 0
        }));

      } catch (err) {
        console.error("getSavedPaymentsApi error", err);
        this.savedBankList = [];
      }
    },
    selectBankAccount(bankId) {
      this.savedBankList.forEach(bank => bank.isSelect = false);
      let selectedBank = this.savedBankList.find(bank => bank.id === bankId);
      selectedBank.isSelect = true;
    },
    async deleteBankAccount(bankId) {
      await deleteSavedPaymentApi({
        paymentMethodId: bankId,
        accountId: this.accountId,
        accountType: this.accountRole
      });
      let index = this.savedBankList.find(bank => bank.id === bankId);
      this.savedBankList.splice(index, 1);
      notify({ type: 'success', title: 'Success', message: 'Successfully delete ACH payment.' })
    },
    async payWithSavedAch() {
      let selectedBank = this.savedBankList.find(bank => bank.isSelect);
      this.$emit('payWithSavedAch', selectedBank);
    },
  }
}
</script>

<style scoped>
.bottom-fixed {
  position: fixed;
  bottom: 89px; 
  z-index: 1000; 
  width: 373px;
  height: 42px;
  right: 52px;
}

.ach-link-button {
  padding: 0;
  font-size: 16px;
  line-height: 24px;
  text-decoration: none;
}
</style>